import React from 'react';

import classnames from 'classnames';

type BackIconProps = {
  className: string;
};

const BackIcon = ({ className }: BackIconProps) => (
  <svg className={classnames(className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 11H7.83L13.415 5.415L12 4L4 12L12 20L13.415 18.585L7.83 13H20V11Z"
      fill="#4A4A4A"
    />
  </svg>
);

export default BackIcon;
